import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../../api/client';
import type {
  CreatePaymentMethodRequest,
  PaymentMethodDto,
  UpdatePaymentMethodRequest,
} from './types';

const QK = ['payment-methods'] as const;

export function usePaymentMethods() {
  return useQuery({
    queryKey: QK,
    queryFn: async () =>
      (await apiClient.get<PaymentMethodDto[]>('/api/payment-methods')).data,
  });
}

export function useCreatePaymentMethod() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (request: CreatePaymentMethodRequest) =>
      (await apiClient.post<PaymentMethodDto>('/api/payment-methods', request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdatePaymentMethod() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, request }: { id: string; request: UpdatePaymentMethodRequest }) =>
      (await apiClient.put<PaymentMethodDto>(`/api/payment-methods/${id}`, request)).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeletePaymentMethod() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (id: string) => {
      await apiClient.delete(`/api/payment-methods/${id}`);
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
